import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;

constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.registerForm = new FormGroup({
      name: new FormControl(),
      email: new FormControl(),
      password: new FormControl(),
    });
  }

  onSubmit() {
    console.log(this.registerForm.value);
    this.authService.signup(
      this.registerForm.controls.name.value,
      this.registerForm.controls.email.value,
      this.registerForm.controls.password.value)
  }

  googleSignIn() {
    console.log("Google Sign In");
    this.authService.googleSignIn();
  }

}
